import { EDateRangeType } from '../../../pages/advertising-research/model/types/DateRangeType.enum'
import { EDateGroup } from '../../enums/DateGroup.enum'
import { IDateRange } from '../../types/DateRange.interface'
import { useDateRanges } from './UseDateRanges'

const dateRanges = useDateRanges()

export const useDateRange = (rangeType: EDateRangeType): IDateRange => {
  switch (rangeType) {
    case EDateRangeType.WEEK:
      return {
        date: dateRanges.week,
        group: EDateGroup.DAY,
      }
    case EDateRangeType.MONTH:
      return {
        date: dateRanges.month,
        group: EDateGroup.WEEK,
      }
    case EDateRangeType.THREE_MONTHS:
      return {
        date: dateRanges.threeMonths,
        group: EDateGroup.WEEK,
      }
    case EDateRangeType.SIX_MONTHS:
      return {
        date: dateRanges.sixMonths,
        group: EDateGroup.MONTH,
      }
    case EDateRangeType.YEAR:
      return {
        date: dateRanges.year,
        group: EDateGroup.MONTH,
      }
  }
}
